export const productPriceHandler = (price, from_data, to_date) => {
  const today = new Date();
  const from = new Date(from_data);
  const to = new Date(to_date);

  const withinPeriod =
    (today >= from && today <= to) || (today >= from && to_date === "");

  return price > 0 && withinPeriod ? price : 0;
};

/**
 * Format Number
 * @param {number} number
 * @returns {string} formatted number or null
 * @example
 * formatPrice(100) // "100"
 * formatPrice(100.50) // "100.50"
 * formatPrice(0) // "0"
 * formatPrice(null) // null
 * formatPrice(NaN) // null
 **/
function intOrFixedNumber(number) {
  if (isNaN(number)) return null;
  const fixedNumber = number?.toFixed(2);
  const [IntPart, floatPart] = String(fixedNumber)?.split(".");
  return floatPart === "00" ? IntPart : fixedNumber;
}

/**
 * Get prices and discount percentage during period between start and end date
 * @param {object} prices {price, original_price, discounted_price_from, discount_price_to}
 * @returns {object} { originalPrice, specialPrice, discount }
 * originalPice == price before discount
 * specialPrice == discounted price during specific period
 * discount is applied discount in percentage (0-100) during specific period
 * discountedPrice = originalPrice - specialPrice
 */
export const validatePrice = (prices) => {
  const now = new Date();
  const startDate = new Date(prices?.discounted_price_from);
  const endDate = new Date(
    prices?.discounted_price_to?.replace("00:00:00", "23:59:59")
  );

  let originalPrice = prices?.original_price;
  let specialPrice = null;
  let discount = null;
  let discountPercentage = null;

  const withinPeriod =
    ((now >= startDate && now <= endDate) ||
      (now >= startDate && prices?.discounted_price_to === "")) &&
    prices?.discounted_price < prices?.original_price;

  if (withinPeriod) {
    specialPrice = prices?.discounted_price;
    discount = ((originalPrice - specialPrice) / originalPrice) * 100;
    discountPercentage = intOrFixedNumber(
      100 - (specialPrice / originalPrice) * 100
    );
  }

  return {
    originalPrice,
    specialPrice,
    discount: Number(discount || 0)?.toFixed(0),
    discountPercentage,
  };
};

/**
 * format price object to use as params in validatePrice function
 * @param {object} item //product item with prices
 * @returns {object} // { price, original_price, discounted_price_from, discount_price_to } formated price object to use as params in validatePrice function
 */
export const priceFormattedObject = (item) => {
  return {
    discounted_price:
      item?.extension_attributes?.special_price ||
      item?.prices_with_tax?.discounted_price ||
      0,
    original_price:
      item?.extension_attributes?.original_price ||
      item?.prices_with_tax?.original_price ||
      0,
    discounted_price_from:
      item?.extension_attributes?.special_price_from ||
      item?.prices_with_tax?.discounted_price_from,
    discounted_price_to:
      item?.extension_attributes?.special_price_to ||
      item?.prices_with_tax?.discounted_price_to ||
      "",
  };
};

export function checkOfferAvailability(startDate, endDate) {
  const currentDate = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  let timeRemaining = null;
  let daysRemaining = null;
  let isAvailable = true;
  // Remove the time part for comparison since the input format does not include time
  currentDate.setHours(0, 0, 0, 0);

  if (currentDate < start) {
    isAvailable = false;
  } else if (currentDate > end) {
    isAvailable = false;
  } else {
    timeRemaining = end - currentDate;
    daysRemaining = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
  }
  return { isAvailable, ...(daysRemaining < 0 && { timeRemaining }) };
}

export function productSkuString(productSku) {
  return Array.isArray(productSku) ? productSku.at(0) : productSku;
}

export const skusArrayHandler = (array = []) => {
  return [...new Set([...array])];
};
